class EditUserPasswordViewController extends MUIViewController
{  
    static newInstance(): EditUserPasswordViewController {
        let vc = new EditUserPasswordViewController("edit-user-password-view");
        vc.initWithResource('layout/edituserprofile/EditUserPasswordView.html');
        return vc;
    }

    private backButton:MUIButton = null;
    private currentPasswordTextField:MUITextField = null;
    private newPasswordTextField:MUITextField = null;
    private retypePasswordTextField:MUITextField = null;
    private changePasswordButton:MUIButton = null;

    private currentPassword:string = null;
    private newPassword:string = null;
    private retypePassword:string = null;

    viewDidLoad(){
        super.viewDidLoad();

        this.backButton = MUIOutlet(this, "back-btn", "MUIButton");
        this.backButton.setAction(this, function (){            
            this.navigationController.popViewController(true);
        });

        this.currentPasswordTextField = MUIOutlet(this, "current-password-tf", "MUITextField");
        this.currentPasswordTextField.setOnChangeText(this, function(this:EditUserPasswordViewController, control:MUITextField, value:string){
            this.currentPassword = value.trim().length > 0 ? value.trim() : null;
        });

        this.newPasswordTextField = MUIOutlet(this, "new-password-tf", "MUITextField");
        this.newPasswordTextField.setOnChangeText(this, function(this:EditUserPasswordViewController, control:MUITextField, value:string){
            this.newPassword = value.trim().length > 0 ? value.trim() : null;
        });

        this.retypePasswordTextField = MUIOutlet(this, "retype-new-password-tf", "MUITextField");
        this.retypePasswordTextField.setOnChangeText(this, function(this:EditUserPasswordViewController, control:MUITextField, value:string){
            this.retypePassword = value.trim().length > 0 ? value.trim() : null;
        });

        this.changePasswordButton = MUIOutlet(this, "save-btn", "MUIButton");
        this.changePasswordButton.setAction(this, function(){
            if (this.currentPassword == null || this.newPassword == null || this.retypePassword == null) {
                AppHelper.showErrorMessage(this, "Error", "Please fill all the fields");
                return;
            }

            if (this.newPassword != this.retypePassword) {
                AppHelper.showErrorMessage(this, "Error", "The new password and the retype password don't match");
                return;
            }

            DualLinkAuthKit.sharedInstance().changeUserPassword(this.currentPassword, this.newPassword, this.retypePassword, (code:number, data:any) => {            
                if (code == 200) {
                    AppHelper.showInfoMessage(this, "Info", "The password was changed successfully");
                    this.navigationController.popViewController(true);
                }
                else {
                    AppHelper.showErrorMessage(this, "Error", "The password couldn't be changed. Please try again later");
                }
            });            
        });
    }

    viewWillAppear(){
        super.viewWillAppear();
        this.updateUI();
    }

    private _user:User = null;
    set user(user:User){
        this._user = user;
    }

    private updateUI(){
        if (this.viewIsLoaded == false) return;

    }




}
